module.exports = __webpack_public_path__ + "img/header.e56dad38.png";